// 项目支持语种，左边是给到 i18n-scanner 的标准语言名字，右边是我们使用的名字，后面迁移到 common-main, 目前使用commonjs的写法
const lngs = {
  zh: 'zh',
  en: 'en',
  ja: 'jp',
  ko: 'ko',
  pt: 'pt',
  ind: 'ind',
};

// 这个参数是语种切换的相关参数，添加了lngs，记得此处对应添加路由信息
const routerLngs = {
  [lngs.zh]: {
    name: '简体中文',
    path: '/zh',
  },
  [lngs.en]: {
    name: 'English',
    path: '',
  },
  [lngs.ja]: {
    // ja jp都是日语的意思，ja i18n使用的标准语区，jp是我们使用的标准
    name: '日本語',
    path: '/jp',
  },
  [lngs.ko]: {
    name: '한국어',
    path: '/ko',
  },
  [lngs.pt]: {
    name: 'Português',
    path: '/pt',
  },
  [lngs.ind]: {
    name: 'Bahasa Indonesia',
    path: '/ind',
  },
};

const lngXls = ['中文', '英文', '日文', '韩文', '葡文']; // 生成翻译文件的title，要注意和lngs数据统一 // , '印尼文'

const isClientContext = Boolean(process.browser); // 是否为客户端

module.exports = {
  lngs,
  lngXls,
  routerLngs,
  isClientContext,
};
